import { MultiSelect } from '@/components/ui/multi-select';
import { SSHInstanceStatusFilterOptions } from '@/service/gpu-instance/type';
import { Input } from '@/components/ui/input';
import { DatePickerWithRange } from '@/components/ui/date-picker/date-range-picker';
import { SearchIcon } from 'lucide-react';
import { DateRange } from 'react-day-picker';

type FormSchemaFilter = {
  searchString: string;
  status: string[];
  date: DateRange | undefined;
};

type Props = {
  filter: FormSchemaFilter;
  onFilterChange: (filter: FormSchemaFilter) => void;
};

const InstanceSearch = ({ filter, onFilterChange }: Props) => {
  // Unique status options for dropdown
  const optionsStatus = SSHInstanceStatusFilterOptions.map((opt) => ({
    value: opt.label,
    label: opt.label,
  }));

  // Convert selected labels to actual status values for filtering
  const handleStatusChange = (selectedLabels: string[]) => {
    const statusValues = selectedLabels.flatMap((label) => {
      const option = SSHInstanceStatusFilterOptions.find((opt) => opt.label === label);
      return option ? option.values : [];
    });
    onFilterChange({ ...filter, status: statusValues });
  };

  // Convert current filter values back to labels for display
  const selectedLabels = SSHInstanceStatusFilterOptions
    .filter((opt) => opt.values.some((v) => filter.status.includes(v)))
    .map((opt) => opt.label);

  return (
    <div className="flex flex-col gap-2 lg:flex-row">
      <div className="flex-1">
        <Input
          value={filter.searchString}
          onChange={(e) => onFilterChange({ ...filter, searchString: e.target.value })}
          placeholder="Search by Project Name or Task ID"
          startIcon={<SearchIcon className="h-4 w-4 text-gray-400" />}
        />
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <MultiSelect
          options={optionsStatus}
          value={selectedLabels}
          onValueChange={handleStatusChange}
          placeholder="Select Status"
          className="w-[220px]"
          compact
        />
        <DatePickerWithRange
          className="w-[250px]"
          value={filter.date}
          onChange={(date) => onFilterChange({ ...filter, date: date as DateRange })}
          placeholder="Filter Date"
        />
      </div>
    </div>
  );
};

export default InstanceSearch;
